export default __webpack_public_path__ + "static/media/kyc-bank-statement.72dab619.svg";